<script lang="ts" setup>
import NextKeyProgress from '@/components/notification/NextKeyProgress.vue';
import { KeyNotificationType, Notification } from '@/types/notification';


const emit = defineEmits(['click']);
const props = defineProps<{ notification?: KeyNotificationType }>();
</script>
<template>
  <div id="key-notification"
    class="bg-shade-dark text-gray-100 shadow-lg w-[90%] rounded-lg mx-10 px-5 py-3 my-2 select-none cursor-pointer"
    @click="$emit('click')">
    <div class="flex gap-3 items-center">
      <SparkIcon icon="key-high-res" class="mb-1" size="20"></SparkIcon>
      <p class="text-lg font-medium w-[90px]">
        <span v-if="notification.data.movementValue > 0">+</span>{{ notification.data.movementValue }}
        {{ notification.data.movementUnit }}
      </p>
      <div class="border-l-1 border-gray-500 w-[1px] h-[20px]"></div>
      <NextKeyProgress :notification="notification" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>
